import React, {useState} from 'react';
import Popup from '../common/components/Popup';
import TextInput from '../common/components/TextInput';
import Select from 'react-select';
import CustomDropdownIndicator from '../common/components/CustomDropdownIndicator';


interface adduserProps {
    showPopup: boolean,
    userRoles: {userRoleId: string, userRoleName: string}[],
    setShowPopup: (value: boolean) => void,
    addUser: (newUser: newUserType) => Promise<boolean>,
}

export interface newUserType {
    firstName: string,
    lastName: string,
    email: string,
    userRoleId: string,
    userRoleName: string
}

function AddUser(props: adduserProps) {
    const {showPopup, userRoles, setShowPopup, addUser} = props;

    const [
        newUser,
        setNewUser,
    ] = useState<newUserType>({
        firstName: '',
        lastName: '',
        email: '',
        userRoleId: '',
        userRoleName: '',
    });

    const [
        loading,
        setLoading,
    ] = useState(false);

    const resetNewUser = (): newUserType => {
        return {
            firstName: '',
            lastName: '',
            email: '',
            userRoleId: '',
            userRoleName: '',
        };
    };

    const handleClose = () => {
        setNewUser(resetNewUser());
        setShowPopup(false);
    };

    const handleOnChange = (text: string, inputId: keyof newUserType) => {
        setNewUser((prevState) => {
            return {
                ...prevState,
                [inputId]: text,
            };
        });
    };

    const handleSelectRole = (role: any) => {
        setNewUser((prevState) => {
            return {
                ...prevState,
                userRoleId: role.value,
                userRoleName: role.label,
            };
        });
    };

    const validateUser = async () => {
        if (newUser.firstName !== '' && newUser.email !== '' && newUser.userRoleId !== '') {
            setLoading(true);
            const canReset = await addUser(newUser);
            if (canReset) {
                setNewUser(resetNewUser());
            }
            setLoading(false);
        }
    };
 
    return (
        <Popup
            show={showPopup}
            onClose={handleClose}
            title='Add User'
            size='sm'
            primaryCtaText='Add User'
            primaryCtaLoading={loading}
            disablePrimaryCta={newUser.email === '' || newUser.firstName === '' || newUser.userRoleId === ''}
            primaryCtaOnClick={validateUser}
            secondaryCtaText='Cancel'
            secondaryCtaOnClick={handleClose}
        >
            <div className='mb-2'>
                <label className='form-label'>First Name</label>
                <TextInput type='text' placeholder='Enter First Name' onChange={(text) => handleOnChange(text, 'firstName')} text={newUser.firstName} style={{width: '100%'}}></TextInput>
            </div>
            <div className='mb-2'>
                <label className='form-label'>Last Name</label>
                <TextInput type='text' placeholder='Enter Last Name' onChange={(text) => handleOnChange(text, 'lastName')} text={newUser.lastName} style={{width: '100%'}}></TextInput>
            </div>
            <div>
                <label className='form-label'>Email ID</label>
                <TextInput type='text' placeholder='Enter Email ID' onChange={(text) => handleOnChange(text, 'email')} text={newUser.email} style={{width: '100%'}}></TextInput>
            </div>
            <div>
                <label className='form-label'>Role</label>
                <Select
                    options={userRoles.map((role) => {
                        return {value: role.userRoleId,
                            label: role.userRoleName};
                    })}
                    value={{value: newUser.userRoleId,
                        label: newUser.userRoleName}}
                    placeholder={'Select Role'}
                    isSearchable
                    onChange={(role) => handleSelectRole(role)}
                    className='input-select'
                    components={{DropdownIndicator: CustomDropdownIndicator}}
                    styles={{
                        indicatorSeparator: (base) => ({
                            ...base,
                            display: 'none',
                        }),
                    }}
                ></Select>
            </div>
        </Popup>
    );
}

export default AddUser;
